import * as o from "react";
import i from "../lib/IconBase.es.js";
import t from "../defs/LinkSimpleHorizontalBreak.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(i, { ref: a, ...r, weights: t }));
e.displayName = "LinkSimpleHorizontalBreakIcon";
const l = e;
export {
  l as LinkSimpleHorizontalBreak,
  e as LinkSimpleHorizontalBreakIcon
};
